
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/json-formatter",
      function () {
        return require("private-next-pages/json-formatter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/json-formatter"])
      });
    }
  